import { useState, useEffect } from 'react'
import { Radio } from 'antd'
import withRepeater from './withRepeater'
import { getDataOptions } from '../helpers'
{ Group } = Radio

SequencedFormRadioInput = ({
  form
  formItem
  repeatItem
  repeatableItems
  options
  config
  derivedData
  queries
  controlled
  props...
}) ->
  [radioOptions, setRadioOptions] = useState(options or [{ label: 'Yes', value: true }, { label: 'No', value: false }])

  useEffect(->
    (->
      if derivedData
        data = await getDataOptions(queries, derivedData)
        if config?.additionalOption
          { additionalOption } = config
          data = data.concat({ label: additionalOption.label, value: additionalOption.value })
        setRadioOptions(data)
    )()
    undefined
  , [])

  <Group { props... }>
    { radioOptions.map((opt) ->
        <Radio
          key={opt.label}
          value={opt.value + ''}
          checked={(opt.value + '') is props.value}
        >
          { opt.label }
        </Radio>
    )}
  </Group>

export default withRepeater(SequencedFormRadioInput)